"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIDGET_REMOTES_SETTINGS = void 0;
var settingsUtils_1 = require("./settingsUtils");
var types_1 = require("./types");
var settings = (0, settingsUtils_1.addFixSettingsIn)({
    type: types_1.MFE_TYPES.widget,
    skipImportingInCMS: false,
}, {
    tpdGiftcardDashcam: {
        __mfeName__: "tpdGiftcardDashcam",
        devClientPort: 6006,
        devServerPort: 6106,
    },
    tpdLocatorWidget: {
        __mfeName__: "tpdLocatorWidget",
        devClientPort: 6033,
        devServerPort: 6133,
    },
    tpdPuTelematica: {
        __mfeName__: "tpdPuTelematica",
        devClientPort: 6031,
        devServerPort: 6131,
    },
    tpdPreventivatoreStickyWidget: {
        __mfeName__: "tpdPreventivatoreStickyWidget",
        devClientPort: 6010,
        devServerPort: 6110,
        mfePriority: 2000,
    },
    tpdRiepilogoPreventivoStickyWidget: {
        __mfeName__: "tpdRiepilogoPreventivoStickyWidget",
        devClientPort: 6075,
        devServerPort: 6175,
    },
    tpdModaleOtp: {
        __mfeName__: "tpdModaleOtp",
        devClientPort: 6034,
        devServerPort: 6134,
    },
    tpdActionModalWidget: {
        __mfeName__: "tpdActionModalWidget",
        devClientPort: 6060,
        devServerPort: 6160,
    },
    tpdNavigationHeader: {
        __mfeName__: "tpdNavigationHeader",
        devClientPort: 7005,
        devServerPort: 7105,
    },
    tpdNoGaranzia: {
        __mfeName__: "tpdNoGaranzia",
        devClientPort: 6043,
        devServerPort: 6143,
    },
    tpdCertificatoAssicurazioneWidget: {
        __mfeName__: "tpdCertificatoAssicurazioneWidget",
        devClientPort: 6058,
        devServerPort: 6158,
    },
    tpdConfiguratoreLandingSticky: {
        __mfeName__: "tpdConfiguratoreLandingSticky",
        devClientPort: 6073,
        devServerPort: 6173,
    },
    tpdValidazioneOtpWidget: {
        __mfeName__: "tpdValidazioneOtpWidget",
        devClientPort: 6080,
        devServerPort: 6180,
    },
    tpdUniboxImmobiliWidget: {
        __mfeName__: "tpdUniboxImmobiliWidget",
        devClientPort: 6081,
        devServerPort: 6181,
    },
    tpdFondiPensioneApertiSearchWidget: {
        __mfeName__: "tpdFondiPensioneApertiSearchWidget",
        devClientPort: 6083,
        devServerPort: 6183,
    },
    tpdFondiPensioneApertiWidget: {
        __mfeName__: "tpdFondiPensioneApertiWidget",
        devClientPort: 6085,
        devServerPort: 6185,
    },
    tpdLancioGestioniSeparateWidget: {
        __mfeName__: "tpdLancioGestioniSeparateWidget",
        devClientPort: 6087,
        devServerPort: 6187,
    },
    tpdListaProdottiEmptyWidget: {
        __mfeName__: "tpdListaProdottiEmptyWidget",
        devClientPort: 6095,
        devServerPort: 6195,
    },
    tpdIniziativaRiepilogo: {
        __mfeName__: "tpdIniziativaRiepilogo",
        devClientPort: 6325,
        devServerPort: 6425,
    },
});
exports.WIDGET_REMOTES_SETTINGS = settings;
